import { Skeleton } from '@/components/ui/skeleton'

export const UserCardSkeleton = () => {
  return (
    <div className="h-full space-y-3 rounded-lg bg-secondary-50 p-3 dark:bg-secondary-600">
      <div className="flex max-w-full items-start justify-between gap-3 overflow-hidden">
        <div className="flex items-stretch gap-3 overflow-hidden">
          <Skeleton className="h-10 w-10 rounded-full" />
          <div className="flex flex-col justify-between">
            <Skeleton className="h-4 w-[120px]" />
            <Skeleton className="h-4 w-[120px]" />
          </div>
        </div>
      </div>
      <Skeleton className="h-4 w-full" />
    </div>
  )
}
